'use client'

import { useMediaQuery } from '@mui/material';
import Card from '@mui/material/Card';

type _props = {
    children: React.ReactNode,
    background?: string,
    padding?: string,
    width?: string,
    className?: string
};

export default function Container(
    {
        children,
        background = '#FFF',
        padding,
        width = 'fit-content',
        className = ''

    }: _props
) {
    const is_mobile = useMediaQuery('(max-width:1024px)');

    return <Card
        sx={{
            width: width,
            margin: 0,
            borderRadius: '12px',
            backgroundColor: background,
            padding: padding ? padding : is_mobile ? '40px 24px' : '40px',
            boxShadow: 'none'
        }}
        className={` ${className}`}
    >
        {children}
    </Card>
};